import React from "react";
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import {dateFormat} from "../../../common";

export default function LineChartComponent(props) {
    console.log(props.data);
    let colorCodes = ["#17607D", "#F2D8A7", "#1FCECB", "#FF9311", "#003D5C", "#F27649", "#D5CDB6", "#008C74", "#30588C", "#263138"]
    let deviceList = ['Web','WAP','Android','IOS'];
    return(
        props.data.length?
        <LineChart width={900} height={300}
                   margin={{top: 5, right: 30, left: 20, bottom: 5}}>

            <XAxis dataKey="perioddatetime" allowDuplicatedCategory={false} height={60} interval={0} type='category' />
            <YAxis/>

            <Tooltip/>
            <Legend />

            {props.data.map((item,index)=>{
                    item.forEach(userData=>{
                        let currentDateFormat = userData.perioddatetime.split(' ');
                        userData.perioddatetime = dateFormat(currentDateFormat[0]);
                    });
                return <Line key={index} name={deviceList[index]} type="monotone" data={item} dataKey="usercount" stroke={colorCodes[index]} />
            })}
        </LineChart>
            :
            <h2>No Data Available</h2>
    )

}